// src/types.ts
export enum ArticleType {
  URL = 'URL',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
}

export interface Article {
  id: number;
  image: string;
  text?: string;
  description: string;
  type: ArticleType;
  link: string;
  tag: string;
  modified_at: string
}


export interface ArticleResponse {
  id: number;
  image: string;
  modified_at: string;
  description: string;
  type: ArticleType;
  link: string;
  target_id?: string;
  tag: string;
}




export interface Device {
  id: number;
  token: string;
  platform: 'android' | 'ios';
  last_registered_at: string;
}

export interface NotificationStatus {
  id: number;
  status: 'sent' | 'received' | 'failed';
  sent_at: string;
  response: string | null;
  device: Device

}



export interface Notification {
  id: number; // notification id
  title: string;
  message: string;
  sent_at: string; // DATETIME as ISO string
  statuses: NotificationStatus[];
}







